// eslint-disable-next-line import/prefer-default-export
export const numberOfOptionsValid = (itemConfig, selectedOptions) => {
  if (itemConfig.min_options !== null) {
    if (itemConfig.min_options > selectedOptions.length) {
      return false;
    }
  }
  if (itemConfig.max_options !== null) {
    if (itemConfig.max_options < selectedOptions.length) {
      return false;
    }
  }
  return true;
};
